export default "__VITE_ASSET__C0I7H2R5__"